<template>
    <div id="pro-cmaj-form" :style="'font-family:' + fontFamily">
        <cmaj-form-header
                class="pt-5 pb-5 header w-100"
                :form-title="formTitle"
                :code="code"
                :loaded="loaded"
                :logo="logo"
                v-if="!noHeader">
        </cmaj-form-header>

        <div class="pro-main-container-bloc pt-5"
             :style="'background-color:' + backGroundColor">
            <div class="mx-auto col-11">
                <cmaj-form-error v-if="code !== null" :code="code"></cmaj-form-error>

                <div class="mt-5 mb-5 row" v-if="loaded && !displayThanks && code === null">
                    <div class="col-4" id="cmaj-menu-container">
                        <cmaj-form-menu :tabulations="tabulations"></cmaj-form-menu>
                    </div>
                    <div class="cmaj-form col-12 col-xl-8">
                        <v-alert type="info"
                                 v-if="txtIntro !== null && txtIntro !== ''"
                                 class="mb-5 form-container mr-auto ml-auto"
                                 border="right"
                                 :color="primaryColor"
                                 colored-border>
                            <div v-if="txtIntro.value" v-html="txtIntro.value"></div>
                            <div v-else v-html="txtIntro"></div>
                        </v-alert>

                        <cmaj-form-tabulations :tabulations="tabulations" :style="'font-family:' + fontFamily"></cmaj-form-tabulations>

                        <cmaj-form-cgu :cgu="cgu" :organism="organism" :style="'font-family:' + fontFamily"></cmaj-form-cgu>

                        <v-alert type="info" :color="primaryColor" v-if="txtIntro !== null"
                                 class="mb-10 form-container mr-auto ml-auto" border="right" colored-border>
                            <div>
                                Attention, après avoir validé vos informations, vous ne pourrez plus les
                                modifier. Il faudra demander un nouveau formulaire à votre Office de Tourisme.
                            </div>
                        </v-alert>

                        <cmaj-form-footer :no-header="noHeader" :style="'font-family:' + fontFamily"></cmaj-form-footer>
                    </div>
                </div>

                <div v-else-if="code === null && !displayThanks" class="mt-5 mb-5 d-flex">
                    <content-placeholders class="cmaj-menu" style="margin-right: 150px">
                        <content-placeholders-text style="width: 300px; height: 51px"></content-placeholders-text>
                        <content-placeholders-heading style="width: 300px; height: 51px"/>
                    </content-placeholders>

                    <content-placeholders class="w-100">
                        <content-placeholders-img style="height: 250px"></content-placeholders-img>
                        <content-placeholders-text></content-placeholders-text>

                        <content-placeholders-heading style="width: 300px; margin-top: 40px">
                        </content-placeholders-heading>
                        <content-placeholders-img
                                style="height: 200px; margin-top: 40px"></content-placeholders-img>
                    </content-placeholders>
                </div>

                <help-modal :referent="referent" v-if="!displayThanks && referent !== null"></help-modal>

                <copyright-modal v-if="code === null"></copyright-modal>

                <opening-period-modal v-if="loaded && code === null"></opening-period-modal>

                <price-period-modal v-if="loaded && code === null"></price-period-modal>

                <forbidden-criteria-modal></forbidden-criteria-modal>

                <form-thanks :organism="organism" :logo="logo"></form-thanks>
            </div>
        </div>
    </div>
</template>

<script>
import CmajFormTabulations from "./CmajFormTabulations.vue"
import CmajFormHeader from "./CmajFormHeader.vue"
import HelpModal from "./modals/HelpModal.vue"
import CopyrightModal from "./modals/CopyrightModal.vue"
import OpeningPeriodModal from "./modals/OpeningPeriodModal.vue"
import PricePeriodModal from "./modals/PricePeriodModal.vue"
import CmajFormError from "./CmajFormError.vue"
import CmajFormMenu from "./CmajFormMenu.vue"
import CmajFormFooter from "./CmajFormFooter.vue"
import CmajFormCgu from "./CmajFormCgu.vue"

import {mapState} from "vuex"
import FormThanks from "./FormThanks.vue";
import ForbiddenCriteriaModal from "./modals/ForiddenCriteriaModal.vue"

export default {
    name: "FormContainer",
    props: ['formTitle', 'code', 'loaded', 'logo', 'noHeader', 'txtIntro', 'cgu', 'organism', 'referent'],
    components: {
        ForbiddenCriteriaModal,
        FormThanks,
        CmajFormCgu,
        CmajFormFooter,
        CmajFormMenu,
        CmajFormError,
        PricePeriodModal,
        OpeningPeriodModal,
        CopyrightModal,
        HelpModal,
        CmajFormHeader,
        CmajFormTabulations
    },
    computed: {
        ...mapState('webFormStyle', ['fontFamily', 'backGroundColor', 'primaryColor']),
        ...mapState('web_form', ['displayThanks', 'tabulations'])
    }
}
</script>

